declare function require(moduleName: string): any;

const {version : appVersion} = require('../../package.json');
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const fromEnv = (key: string) => {
    const env = (window as any).env;
    if(!(key in env))     {
        throw new Error(`Could not read environment variable ${key}`);
    }
    return env[key];
};

export const environment = {
    production: fromEnv('production')  === 'true',
    baseHref: fromEnv('baseHref'),
    auditlogUrl: fromEnv('auditlogUrl'),
    authenticationBaseUrl: fromEnv('authenticationBaseUrl'),
    managementApiUrl: fromEnv('managementApiUrl'),
    providersApiUrl: fromEnv('providersApiUrl'),
    subBoardApiUrl: fromEnv('subBoardApiUrl'),
    officeAppUrl: fromEnv('officeAppUrl'),
    seqLoggingEndpoint: fromEnv('seqLoggingEndpoint'),
    categoryIconsCDN: fromEnv('categoryIconsCDN'),
    seqLoggingApiKey: fromEnv('seqLoggingApiKey'),
    adTenant: fromEnv('adTenant'),
    adClientId: fromEnv('adClientId'),
    employeeApiUrl: fromEnv('employeeApiUrl'),
    buildId: fromEnv('buildId'),
    authMode: fromEnv('authMode'),
    adRedirectUri: fromEnv('adRedirectUri'),
    managementApiScope: fromEnv('managementApiScope'),
    subBoardApiScope: fromEnv('subBoardApiScope'),
    employeeApiScope: fromEnv('employeeApiScope'),
    providersApiScope: fromEnv('providersApiScope'),
    auditlogApiScope: fromEnv('auditlogApiScope'),
    environment: fromEnv('environment'),
    observabilityEnabled: fromEnv('observabilityEnabled'),
    observabilityServiceName: fromEnv('observabilityServiceName'),
    observabilityServiceNamespace: fromEnv('observabilityServiceNamespace'),
    appVersion,

    get isMsalAuthenticationEnabled() { return this.authMode === 'msal'; }
  };
